import { useEffect, useState } from "react";
import * as DatePickerModule from "react-multi-date-picker";

const DatePicker =
  DatePickerModule.default?.default || DatePickerModule.default;
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "../../../styles/panel/user/Profile.css";
import DocumentUpload from "./DocumentUpload";
import ChangePasswordModal from "./ChangePasswordModal";
import http from "../../../api/http";

// چون تاریخ تولد همیشه به‌صورت شمسی (YYYY-MM-DD) هم در استیت و هم برای سرور
// نگه‌داری می‌شود، فقط برای نمایش، خط تیره را به اسلش و ارقام را به فارسی تبدیل می‌کنیم.
function formatJalaliForDisplay(jalaliDate) {
  if (!jalaliDate) return "";
  return toPersianDigits(jalaliDate.replaceAll("-", "/"));
}

// تبدیل ارقام فارسی/عربی به انگلیسی (برای ذخیره در استیت و ارسال به سرور)
const PERSIAN_DIGITS = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
const ARABIC_DIGITS = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];

function toEnglishDigits(value) {
  if (value === null || value === undefined) return "";
  return value
    .toString()
    .replace(/[۰-۹]/g, (d) => PERSIAN_DIGITS.indexOf(d))
    .replace(/[٠-٩]/g, (d) => ARABIC_DIGITS.indexOf(d));
}

// تبدیل ارقام انگلیسی به فارسی (فقط برای نمایش در UI)
function toPersianDigits(value) {
  if (value === null || value === undefined) return "";
  return value.toString().replace(/\d/g, (d) => PERSIAN_DIGITS[d]);
}
// اعتبارسنجی کد ملی ایران (الگوریتم رسمی چک‌دیجیت)
function isValidNationalCode(code) {
  if (!/^\d{10}$/.test(code)) return false;
  if (/^(\d)\1{9}$/.test(code)) return false; // اعداد تکراری مثل 1111111111

  const digits = code.split("").map(Number);
  const checkDigit = digits[9];
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += digits[i] * (10 - i);
  }
  const remainder = sum % 11;
  return remainder < 2
    ? checkDigit === remainder
    : checkDigit === 11 - remainder;
}

export default function Profile() {
  const [profile, setProfile] = useState("");
  const [draft, setDraft] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [errors, setErrors] = useState({});
  const [undertakingFile, setUndertakingFile] = useState(null);
  const [nationalIdFile, setNationalIdFile] = useState(null);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  useEffect(() => {
    http
      .get("/auth/profile/")
      .then((res) => {
        const data = res.data;

        const profileData = {
          firstName: data.first_name || "",
          lastName: data.last_name || "",
          nationalCode: data.national_code || "",
          // تاریخ تولد از بک‌اند به‌صورت شمسی (YYYY-MM-DD) می‌آید و همان‌طور نگه داشته می‌شود
          birthDate: data.birth_date || "",
        };
        setUndertakingFile(data.commitment_letter_image || null);
        setNationalIdFile(data.national_card_image || null);

        setProfile(profileData);
        setDraft(profileData);
      })
      .catch((err) => {
        console.error("خطا در دریافت پروفایل:", err);
      });
  }, []);

  const startEdit = () => {
    setDraft(profile);
    setErrors({});
    setIsEditing(true);
  };

  const cancelEdit = () => {
    setDraft(profile);
    setErrors({});
    setIsEditing(false);
  };

  const handleChange = (field) => (e) => {
    let value = e.target.value;

    // کد ملی همیشه به‌صورت ارقام انگلیسی در استیت و برای سرور نگه‌داری می‌شود،
    // حتی اگر کاربر با کیبورد فارسی رقم فارسی/عربی تایپ کند.
    if (field === "nationalCode") {
      value = toEnglishDigits(value).replace(/[^0-9]/g, "");
    }

    setDraft((prev) => ({ ...prev, [field]: value }));
  };

  const handleBirthDateChange = (dateObject) => {
    if (!dateObject) {
      setDraft((prev) => ({ ...prev, birthDate: "" }));
      return;
    }
    // بدون تبدیل به میلادی؛ همون تاریخ شمسی ذخیره می‌شود، ولی ارقام همیشه انگلیسی
    // نگه داشته می‌شوند تا هنگام ارسال به سرور مشکلی پیش نیاید.
    setDraft((prev) => ({
      ...prev,
      birthDate: toEnglishDigits(dateObject.format("YYYY-MM-DD")),
    }));
  };

  // const validate = () => {
  //   const newErrors = {};

  //   if (!draft.firstName.trim()) {
  //     newErrors.firstName = "نام را وارد کنید";
  //   }
  //   if (!draft.lastName.trim()) {
  //     newErrors.lastName = "نام خانوادگی را وارد کنید";
  //   }
  //   // if (!draft.nationalCode.trim()) {
  //   //   newErrors.nationalCode = "کد ملی را وارد کنید";
  //   // } else
  //   //   if (!isValidNationalCode(draft.nationalCode.trim())) {
  //   //   newErrors.nationalCode = "کد ملی معتبر نیست";
  //   // }
  //   // if (!draft.birthDate) {
  //   //   newErrors.birthDate = "تاریخ تولد را وارد کنید";
  //   // }

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  const handleSave = async () => {
    try {
      // if (!validate()) return;

      const formData = new FormData();

      formData.append("first_name", draft.firstName.trim());
      formData.append("last_name", draft.lastName.trim());
      formData.append("national_code", draft.nationalCode.trim());
      // تاریخ تولد همون‌طور که هست (شمسی، YYYY-MM-DD) به سرور ارسال می‌شود
      formData.append("birth_date", draft.birthDate);

      // فقط وقتی کاربر فایل جدیدی انتخاب کرده (یعنی واقعاً یک File/Blob است)
      // آن را می‌فرستیم؛ اگر مقدار فعلی همان URL برگشتی از سرور باشد (رشته)،
      // نباید دوباره ارسال شود چون باعث خطا در بک‌اند می‌شود.
      if (undertakingFile instanceof File) {
        formData.append("commitment_letter_image", undertakingFile);
      }

      if (nationalIdFile instanceof File) {
        formData.append("national_card_image", nationalIdFile);
      }

      const res = await http.patch("/auth/profile/", formData);

      const updatedProfile = {
        firstName: res.data.first_name || "",
        lastName: res.data.last_name || "",
        nationalCode: res.data.national_code || "",
        birthDate: res.data.birth_date || "",
      };

      setProfile(updatedProfile);
      setDraft(updatedProfile);

      setIsEditing(false);
      setErrors({});
    } catch (error) {
      console.error("خطا در ذخیره پروفایل:", error);

      console.log("Backend error:", error.response?.data);
    }
  };

  // ذخیره‌ی مدارک (تعهدنامه و کارت ملی) کاملاً مستقل از فرم اطلاعات هویتیه؛
  // برخلاف handleSave نیازی به پر بودن نام/نام‌خانوادگی/کدملی/تاریخ تولد نداره.
  const handleSaveDocuments = async () => {
    const formData = new FormData();

    if (undertakingFile instanceof File) {
      formData.append("commitment_letter_image", undertakingFile);
    }

    if (nationalIdFile instanceof File) {
      formData.append("national_card_image", nationalIdFile);
    }

    // اگر کاربر فایل جدیدی انتخاب نکرده، اصلاً درخواستی به سرور نفرست
    if (![...formData.keys()].length) return;

    try {
      const res = await http.patch("/auth/profile/", formData);

      setUndertakingFile(res.data.commitment_letter_image || undertakingFile);
      setNationalIdFile(res.data.national_card_image || nationalIdFile);
    } catch (error) {
      console.error("خطا در ذخیره مدارک:", error);
      console.log("Backend error:", error.response?.data);
      // throw می‌کنیم تا DocumentUpload بفهمه ذخیره واقعاً شکست خورده
      // و پیام موفقیت‌آمیز اشتباه نشون نده
      throw error;
    }
  };

  // فعلاً بک‌اند نداریم؛ وقتی آماده شد خط کامنت‌شده را فعال کنید.
  // اگر throw شود، مودال پیام خطا نشان می‌دهد.
  const handleChangePassword = async (newPassword) => {
    // await http.post("/auth/change-password/", { new_password: newPassword });
    console.log("رمز عبور جدید (فعلاً فقط تست):", newPassword);
  };

  const fields = [
    { key: "firstName", label: "نام", type: "text", placeholder: "مثلاً امیر" },
    {
      key: "lastName",
      label: "نام خانوادگی",
      type: "text",
      placeholder: "مثلاً رضایی",
    },
    {
      key: "nationalCode",
      label: "کد ملی",
      type: "text",
      placeholder: "مثلاً ۰۰۱۲۳۴۵۶۷۸",
      inputMode: "numeric",
      maxLength: 10,
    },
    { key: "birthDate", label: "تاریخ تولد", type: "date" },
  ];

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-header-text">
          <h1>پروفایل</h1>
          <p>اطلاعات هویتی خود را مشاهده و ویرایش کنید.</p>
        </div>
      </div>
      <div className="profile-layout">
        <aside className="profile-sidebar">
          <div className="profile-avatar">
            {(profile.firstName?.[0] || "") + (profile.lastName?.[0] || "")}
          </div>
          <div className="profile-avatar-name">
            {profile.firstName} {profile.lastName}
          </div>
          <div className="profile-avatar-sub">
            کد ملی: {toPersianDigits(profile.nationalCode)}
          </div>
        </aside>

        <div className="profile-card">
          <div className="profile-card-actions">
            <button
              type="button"
              className="profile-text-btn"
              onClick={() => setIsPasswordModalOpen(true)}
            >
              ویرایش رمز عبور
            </button>

            {isEditing ? (
              <>
                <button
                  type="button"
                  className="profile-icon-btn confirm"
                  onClick={handleSave}
                  aria-label="ذخیره تغییرات"
                  title="ذخیره تغییرات"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                </button>
                <button
                  type="button"
                  className="profile-icon-btn cancel"
                  onClick={cancelEdit}
                  aria-label="انصراف"
                  title="انصراف"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 6L6 18" />
                    <path d="M6 6l12 12" />
                  </svg>
                </button>
              </>
            ) : (
              <button
                type="button"
                className="profile-icon-btn edit"
                onClick={startEdit}
                aria-label="ویرایش اطلاعات"
                title="ویرایش اطلاعات"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 20h9" />
                  <path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4L16.5 3.5z" />
                </svg>
              </button>
            )}
          </div>

          <div className="profile-form-grid">
            {fields.map((field) => (
              <div className="profile-field" key={field.key}>
                <label htmlFor={field.key}>{field.label}</label>

                {isEditing ? (
                  <>
                    {field.key === "birthDate" ? (
                      <DatePicker
                        id="birthDate"
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        value={
                          draft.birthDate
                            ? new DateObject({
                                date: draft.birthDate,
                                format: "YYYY-MM-DD",
                                calendar: persian,
                                locale: persian_fa,
                              })
                            : null
                        }
                        onChange={handleBirthDateChange}
                        format="YYYY-MM-DD"
                        editable={false}
                        inputClass={
                          "profile-jalali-input" +
                          (errors.birthDate ? " invalid" : "")
                        }
                        containerClassName="profile-jalali-container"
                        placeholder="انتخاب تاریخ تولد"
                      />
                    ) : (
                      <input
                        id={field.key}
                        type={field.type}
                        inputMode={field.inputMode}
                        maxLength={field.maxLength}
                        placeholder={field.placeholder}
                        value={
                          field.key === "nationalCode"
                            ? toPersianDigits(draft[field.key])
                            : draft[field.key]
                        }
                        onChange={handleChange(field.key)}
                        className={errors[field.key] ? "invalid" : ""}
                      />
                    )}
                    <span className="field-error">
                      {errors[field.key] || "\u00A0"}
                    </span>
                  </>
                ) : (
                  <div className="profile-value">
                    {field.key === "birthDate"
                      ? profile.birthDate
                        ? formatJalaliForDisplay(profile.birthDate)
                        : "—"
                      : field.key === "nationalCode"
                        ? profile.nationalCode
                          ? toPersianDigits(profile.nationalCode)
                          : "—"
                        : profile[field.key] || "—"}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <DocumentUpload
        undertakingFile={undertakingFile}
        nationalIdFile={nationalIdFile}
        onUndertakingChange={setUndertakingFile}
        onNationalIdChange={setNationalIdFile}
        onSave={handleSaveDocuments}
      />

      {isPasswordModalOpen && (
        <ChangePasswordModal
          onClose={() => setIsPasswordModalOpen(false)}
          onSubmit={handleChangePassword}
        />
      )}
    </div>
  );
}
